module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "senff-return"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Obrigado por comprar com Senff.")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n        Seu pagamento está sendo processado. O notificaremos quando terminar. Você tambem pode monitorar seus pedidos abaixo.\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn requests",
    attrs: {
      "id": "requests",
      "type": "submit",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToRequests()
      }
    }
  }, [_c('span', {
    staticClass: "text-btn-requests"
  }, [_vm._v("Meus pedidos")]), _vm._v(" "), _c('i', {
    staticClass: "icon-coin align-icon-right-lg"
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-82ed9a0e!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/retorno-senff.vue
// module id = 2186
// module chunks = 1